"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogFooterButtonsWidget = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var ButtonWidgetShim_1 = require("../Button/ButtonWidgetShim");
var StyleName = TypeStyle.style({
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'flex-end',
    $nest: {
        '& > button ~ button': { marginLeft: TabStyles_1.TabStyles.Spacing.MediumSpace }
    }
});
/** A convenience widget for use in the `footerContent` prop of `DialogWidget`, which aligns and spaces buttons in a standardized way. */
exports.DialogFooterButtonsWidget = function (props) {
    return React.createElement("div", { className: StyleName, "data-tb-test-id": Declarative_1.makeTestId(props.testId, 'Confirm-Cancel-Footer') }, props.buttons.map(function (buttonProps, idx) { return React.createElement(ButtonWidgetShim_1.ButtonWidget, tslib_1.__assign({ key: idx }, buttonProps)); }));
};
exports.DialogFooterButtonsWidget.displayName = 'DialogFooterButtonsWidget';
//# sourceMappingURL=DialogFooterButtonsWidget.js.map